<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <template slot="header" v-if="!modal">
            Cierre de Movimientos
          </template>
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco"
                :value="banco" 
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Moneda"
              label-for="moneda"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="moneda"
                :value="moneda" 
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nro. Cuenta"
              label-for="cuentaNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuentaNumero"
                :value="cuentaNumero" 
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Cierre"
              label-for="fechaCierre"
              :labelCols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="fechaCierreHabilitada"
                      v-model="fechaCierreHabilitada"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="fechaCierre" 
                  v-model= "fechaCierre" 
                  type="date"
                  :disabled= "fechaCierreDisabled">
                </b-form-input>
              </b-input-group>
            </b-form-group>

          </b-form>
          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>

        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if="!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancocuentacierre/getField',
  mutationType: 'bancocuentacierre/updateField',
});

export default {
  name: 'BancoCuentaCierre',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    bancoCuentaId: {
      type: Number,
      default: 0
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fechaCierreDisabled: false,

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'banco',
      'moneda',
      'cuentaNumero',
      'fechaCierre',
      'fechaCierreHabilitada',
    ])
  },  
  created() {
    let bancoCuentaId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        bancoCuentaId = this.$route.params.id;
      }
    }

    if (this.bancoCuentaId != 0) {
      bancoCuentaId = this.bancoCuentaId;
    }

    this.showSpinner();
    this.$store.dispatch('bancocuentacierre/inicializar', bancoCuentaId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    save () {
      this.showSpinner();
      this.$store.dispatch('bancocuentacierre/save')
        .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.cierreActualizado, this.cierreActualizado, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    goBack() {
      if (this.modal) {
        this.$emit('close');
      } else {
        this.$router.push({ name: "BancosCuentas" });
      }
    },
    cierreActualizado() {
      if (this.modal) {
        this.$emit('cierreActualizado'); 
      } else {
        this.$router.push({ name: "BancosCuentas" });
      }
    },
  },
  watch: {
    'fechaCierreHabilitada' : function(newVal, oldVal) {
      this.fechaCierreDisabled = !(/true/i).test(this.fechaCierreHabilitada);
    },
  }    
}
</script>

<style>
</style>
